import MedicareCardProtector from '@components/pages/medicare-card-protector';

const MedicareCardProtectorPage = () => <MedicareCardProtector />;

export default MedicareCardProtectorPage;
